module.exports = __webpack_public_path__ + "img/hiking003.ed481c02.jpg";